import React from 'react';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  className?: string;
}
export function PageHero({
  title,
  subtitle,
  className = ''
}: PageHeroProps) {
  return <section className={`relative pt-32 pb-20 md:pt-40 md:pb-28 bg-gradient-to-br from-teal to-sage text-white overflow-hidden ${className}`} data-id="element-182">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-full h-full opacity-10 pointer-events-none" data-id="element-183">
        <svg viewBox="0 0 100 100" className="absolute top-0 right-0 w-1/2 h-full text-white fill-current" data-id="element-184">
          <path d="M0 0 C 50 0 50 100 100 100 L 100 0 Z" data-id="element-185" />
        </svg>
      </div>

      {/* Animated Path */}
      <div className="absolute bottom-0 left-0 w-full h-32 pointer-events-none opacity-20" data-id="element-186">
        <svg className="w-full h-full" viewBox="0 0 1200 100" preserveAspectRatio="none" data-id="element-187">
          <path d="M0,50 Q300,100 600,50 T1200,50" fill="none" stroke="white" strokeWidth="2" className="animate-draw-path" strokeDasharray="1200" strokeDashoffset="1200" data-id="element-188" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-189">
        <div className="max-w-3xl animate-fade-in-up" data-id="element-190">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium mb-6 text-balance" data-id="element-191">
            {title}
          </h1>
          {subtitle && <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed text-balance max-w-2xl" data-id="element-192">
              {subtitle}
            </p>}
        </div>
      </div>
    </section>;
}